import { render } from "./Collaboration.vue?vue&type=template&id=2260106f&scoped=true&ts=true"
import script from "./Collaboration.vue?vue&type=script&lang=ts"
export * from "./Collaboration.vue?vue&type=script&lang=ts"

import "./Collaboration.vue?vue&type=style&index=0&id=2260106f&scoped=true&lang=less"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2260106f"]])

export default __exports__